// extracted by mini-css-extract-plugin
module.exports = {"container":"Jumbotron_container__MfG09","icon1":"Jumbotron_icon1__aA_sl","icon2":"Jumbotron_icon2__22kMI","icon3":"Jumbotron_icon3__IMyPy"};